import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

export const RESOURCE_TYPE_REQUIREMENTS = [] as const satisfies readonly ResourceTypeHandle[];
